import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, forwardRef } from 'react';
import { Input as AntdInput } from 'antd';
import styled, { css } from 'styled-components';
export const InputFieldWrapper = styled.div `
  position: relative;
  ${({ required }) => required &&
    css `
      &:before {
        content: '*';
        position: absolute;
        top: -2px;
        left: 16px;
        color: #ff4016;
        height: 12px;
        font-size: 18px;
        line-height: 12px;
        z-index: 4;
      }
    `}
`;
export const InputField = styled(AntdInput) `
  &.bc-input-filled {
    --bc-font-family: 14px;
    --bc-line-height: calc(14px + 4px);
    --bc-border-radius: 15px;
    --bc-input-padding-block: calc(calc(5 * 1px) * 2);
    --bc-input-padding-inline: calc(calc(5 * 1px) * 3);
    --bc-color-fill-tertiary: hsla(0, 0%, 0%, 0.07);
    --bc-color-text: hsla(0, 0%, 33.33%, 1) !important;
    border-color: transparent;

    &.bc-input-status-error:not(.bc-input-disabled) {
      box-shadow: inset 0 0 0 2px
        hsla(
          var(--ue-danger-color_h, 2),
          var(--ue-danger-color_s, 77%),
          var(--ue-danger-color_l, 64%),
          var(--ue-danger-color_t, 1)
        ) !important;
    }
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    pointer-events: auto;
    --bc-color-fill-tertiary: hsla(0, 0%, 0%, 0.07);
    --bc-color-text-disabled: hsla(0, 0%, 33.33%, 1) !important;
    background: var(--bc-color-fill-tertiary);
  }
  &:focus-visible:not(:disabled) {
    outline: none;
    box-shadow: inset 0 0 0 2px hsla(129, 60%, 50%, 1), 0 0 0 4px #0091ff45;
  }
  &:focus:not(:disabled),
  &:hover:not(:disabled),
  .bc-input-affix-wrapper-focused {
    --bc-color-fill-tertiary: hsla(
      var(--ue-input-hover-color_h, 0),
      var(--ue-input-hover-color_s, 0%),
      var(--ue-input-hover-color_l, 0%),
      var(--ue-input-hover-color_t, 0.1)
    );
    box-shadow: inset 0 0 0 2px hsla(129, 60%, 50%, 1);
  }
`;
export const ErrorMessage = styled.div `
  position: absolute;
  min-width: calc(calc(calc(5 * 1px) * 3) * 2 + 47px);
  bottom: calc(100% + calc(5 * 1px) - 2px);
  z-index: 15;
  opacity: 0;
  transform: scale(0);

  ${InputFieldWrapper}:hover & {
    ${({ error }) => error &&
    css `
        animation: ca-error-show 0.15s cubic-bezier(0, 0, 0.2, 1) forwards;
      `};
  }

  span {
    background-color: hsla(2, 77%, calc(64% - 3%), 1);
    ${({ error }) => error &&
    css `
        padding: calc(calc(var(--ue-spacing-step-px, 1) * 1px) + 2px) calc(calc(5 * 1px) * 2);
      `};
    border-radius: 15px;
    min-width: calc(calc(calc(5 * 1px) * 3) * 2 + 47px);
    text-align: center;
    box-sizing: border-box;
    font-size: calc(14px - 2px);
    line-height: 14px;
    color: hsla(
      var(--ue-secondary-font-color_h, 0),
      var(--ue-secondary-font-color_s, 0%),
      var(--ue-secondary-font-color_l, 100%),
      var(--ue-secondary-font-color_t, 1)
    );
  }

  @keyframes ca-error-show {
    0% {
      opacity: 0;
      transform: scale(0);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;
const Input = forwardRef(({ id, name, value, onChange, disabled = false, type = 'text', info, onBlur, required = false, error, WrapperStyle, ...rest }, ref) => {
    const inputId = useId();
    return (_jsxs(InputFieldWrapper, { required: required, style: WrapperStyle, children: [_jsx(InputField, { name: name, id: id || inputId, type: type, value: value, required: required, onChange: onChange, onBlur: onBlur, disabled: disabled, status: error ? 'error' : undefined, ...rest }), _jsx(ErrorMessage, { error: error, children: _jsx("span", { children: error }) })] }));
});
export default Input;
